import { EAccountStatuses } from 'types/userTypes';

export const stylesByStatus = {
  [EAccountStatuses.Initial]: 'hidden',
  [EAccountStatuses.Pending]: 'bg-yellow-10 text-orange-50',
  [EAccountStatuses.Approved]: 'bg-green-10 text-green-50',
  [EAccountStatuses.Declined]: 'bg-red-10 text-red-50',
  [EAccountStatuses.FinalDeclined]: 'bg-red-10 text-red-50',
};

export const textByStatus = {
  [EAccountStatuses.Initial]: '',
  [EAccountStatuses.Pending]: 'Pending',
  [EAccountStatuses.Approved]: 'Approved',
  [EAccountStatuses.Declined]: 'Not Approved',
  [EAccountStatuses.FinalDeclined]: 'Not Approved',
};

export const popoverContentByStatus = {
  [EAccountStatuses.Initial]: null,
  [EAccountStatuses.Pending]: (
    <div className="text-11">
      <p>You will be approved after moderator will check your data</p>
      <a className="blue" href="mailto:support@autods.com">Contact us</a>
    </div>
  ),
  [EAccountStatuses.Approved]: null,
  [EAccountStatuses.Declined]: <div className="text-11">Please check your email</div>,
  [EAccountStatuses.FinalDeclined]: <div className="text-11">Please check your email</div>,
};
